import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *proceedLoop($this, $completion) {
  $l$loop_0: do {
    var index = $this.x4r_1;
    if (index === -1) {
      break $l$loop_0;
    }
    var interceptors = $this.u4r_1;
    if (index >= interceptors.q2()) {
      $this.y4r();
      break $l$loop_0;
    }
    var executeInterceptor = interceptors.r2(index);
    $this.x4r_1 = index + 1 | 0;
    yield* executeInterceptor($this, $this.w4r_1, $completion);
  }
   while (true);
  return $this.w4r_1;
}
var DebugPipelineContextClass;
function DebugPipelineContext() {
  if (DebugPipelineContextClass === VOID) {
    class $ extends PipelineContext() {
      constructor(context, interceptors, subject, coroutineContext) {
        super(context);
        this.u4r_1 = interceptors;
        this.v4r_1 = coroutineContext;
        this.w4r_1 = subject;
        this.x4r_1 = 0;
      }
      cw() {
        return this.v4r_1;
      }
      z4r() {
        return this.w4r_1;
      }
      y4r() {
        this.x4r_1 = -1;
      }
      *a4s(subject, $completion) {
        this.w4r_1 = subject;
        return yield* this.b4s($completion);
      }
      *b4s($completion) {
        var index = this.x4r_1;
        if (index < 0)
          return this.w4r_1;
        if (index >= this.u4r_1.q2()) {
          this.y4r();
          return this.w4r_1;
        }
        return yield* /*#__NOINLINE__*/proceedLoop(this, $completion);
      }
      *c4s(initial, $completion) {
        this.x4r_1 = 0;
        this.w4r_1 = initial;
        return yield* this.b4s($completion);
      }
    }
    initMetadataForClass($, 'DebugPipelineContext', VOID, VOID, VOID, [1, 0]);
    DebugPipelineContextClass = $;
  }
  return DebugPipelineContextClass;
}
//region block: exports
export {
  DebugPipelineContext as DebugPipelineContext2zfnr2i0vcihk,
};
//endregion

//# sourceMappingURL=DebugPipelineContext.mjs.map
